import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";

export interface Question {
  question: string;
  answer: string;
}

interface Questions {
  questions: Question[];
}

export const initialState: Questions = {
  questions: [],
};

const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {
    setQuestions(state, action: PayloadAction<Question[]>) {
      state.questions = action.payload;
    },
    logoutQuestions() {
      return initialState;
    },
  },
});

export const selectQuestions = (state: RootState) => state.questions.questions;

export const { setQuestions, logoutQuestions } = questionSlice.actions;
export default questionSlice.reducer;
